import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import {
  CreateProductParams,
  DeleteProductByIdResponse,
  GetProductByIdResponse, GetProductRequestParams,
  GetProductResponse, UpdateProductRequestParams
} from '../../pages/products/products.interface';
import { environment } from '../../../environments/environment';
import { toQueryString } from '../../shared/helpers/helpers';

import { GetProductListResponse } from '../../interfaces/products.interface';


@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  private apiUrl = environment.api + '/products';
  private tokenKey = environment.accessTokenName;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(this.tokenKey)}`
    });
  }

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getProductService(requestParams: GetProductRequestParams): Observable<GetProductResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetProductResponse>(url, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError(error => this.handleError(error))   // ✅ Pakai arrow function
    );
  }

  getProductById(id: string): Observable<GetProductByIdResponse> {
    return this.http.get<GetProductByIdResponse>(`${this.apiUrl}/${id}`, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  deleteProductById(id: string): Observable<DeleteProductByIdResponse> {
    return this.http.delete<DeleteProductByIdResponse>(`${this.apiUrl}/${id}`, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  createProduct(productData: CreateProductParams): Observable<GetProductByIdResponse> {
    return this.http.post<GetProductByIdResponse>(this.apiUrl, productData, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  updateProduct(id: string, productData: UpdateProductRequestParams): Observable<GetProductByIdResponse> {
    return this.http.put<GetProductByIdResponse>(`${this.apiUrl}/${id}`, productData, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }


  syncDigiflazz(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/sync-digiflazz`, {}, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  getProducts(): Observable<GetProductListResponse> {
    return this.http.get<GetProductListResponse>(this.apiUrl, { headers: this.getHeaders() }).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }
}
